<template>
  <div>
    <el-table :data="tracks" class="w100" stripe>
      <el-table-column label="Campaign Name" prop="name"></el-table-column>
      <el-table-column label="Track Name" prop="track.title"></el-table-column>
      <el-table-column
          label="Campaign Package"
          prop="campaign_packages.name"
      ></el-table-column>
      <el-table-column label="Balance" prop="balance">
        <template slot-scope="props">
          {{ props.row.balance ? '$'+props.row.balance.toFixed(2) : '/' }}
        </template>
      </el-table-column>
      <el-table-column label="Campaign start">
        <template slot-scope="props">
          {{ props.row.campaign_track_start | date }}
        </template>
      </el-table-column>
      <el-table-column label="Campaign end">
        <template slot-scope="props">
          {{ props.row.campaign_track_end | date }}
        </template>
      </el-table-column>
      <el-table-column label="Tier timeout" prop="bronze_tier_timeout"></el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip content="Edit" placement="top">
            <el-button
              class="mt10"
              type="info"
              circle
              size="small"
              icon="el-icon-edit"
              @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import axios from '@/plugins/axios'

export default {
  computed: {
    ...mapState('vcTrack', ['tracks'])
  },

  methods: {
    ...mapMutations('vcTrack', [
      'setTrack',
      'setTrackDeposit',
      'setEditDialog',
      'setActiveCampaign'
    ]),

    openDeposit(row) {
      this.setTrackDeposit(true)
      this.setTrack(row)
    },
    async openEdit(row) {
      this.setActiveCampaign(row)

      await axios.admin.get(`campaign/${row.id}/bonuses`)
          .then(res => {
            row['bonuses'] = res.data.bonuses
            this.setTrack(JSON.parse(JSON.stringify(row)))
            this.setEditDialog(true)
          })
    }
  }
}
</script>
